import { useState, useEffect } from 'react';

export function usePWAInstall() {
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
    const [isInstallable, setIsInstallable] = useState(false);
    const [isInstalled, setIsInstalled] = useState(false);
    const [isIOS, setIsIOS] = useState(false);

    useEffect(() => {
        // Detectar si ya está instalada o ejecutándose en modo standalone
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches 
            || (navigator as any).standalone 
            || document.referrer.includes('android-app://');
            
        setIsInstalled(isStandalone);

        // Detectar si el dispositivo es iOS
        const userAgent = window.navigator.userAgent.toLowerCase();
        const ios = /iphone|ipad|ipod/.test(userAgent);
        setIsIOS(ios);

        // Escuchar el evento de instalación de PWA de los navegadores basados en Chromium
        const handleBeforeInstallPrompt = (e: Event) => {
            // Evitar que el navegador muestre automáticamente el prompt predeterminado
            e.preventDefault();
            // Guardar el evento para dispararlo cuando el usuario haga clic
            setDeferredPrompt(e);
            setIsInstallable(true);
        };

        const handleAppInstalled = () => {
            setDeferredPrompt(null);
            setIsInstallable(false);
            setIsInstalled(true);
            console.log('[PWA] SkyMenu instalada correctamente.');
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);

    const installApp = async (): Promise<boolean> => {
        if (!deferredPrompt) {
            console.warn('[PWA] No hay un prompt diferido disponible para instalar.');
            return false;
        }

        // Mostrar el prompt nativo
        deferredPrompt.prompt();

        // Esperar la decisión del usuario
        try {
            const { outcome } = await deferredPrompt.userChoice;
            console.log(`[PWA] Decisión del usuario: ${outcome}`);
            
            if (outcome === 'accepted') {
                setDeferredPrompt(null);
                setIsInstallable(false);
                return true;
            }
        } catch (error) {
            console.error('[PWA] Error en el flujo de instalación:', error);
        }

        return false;
    };

    return {
        isInstallable,
        isInstalled,
        isIOS,
        showIOSPrompt: isIOS && !isInstalled,
        installApp,
    };
}
